import React, { useEffect } from "react";
import useSpeechToText from "react-hook-speech-to-text";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import Speech from "speak-tts";

export default function ReactHookSpeech() {
  /* ------------------- Speech recognition section methods ------------------- */
  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition,
  } = useSpeechRecognition();


  const speech = new Speech();
  speech
    .init({
      volume: 1,
      lang: "en-GB",
      rate: 1,
      pitch: 1,
      voice: "Google UK English Female",
      // splitSentences: true,
      listeners: {
        onvoiceschanged: (voices) => {
          console.log("Event voiceschanged", voices);
        },
      },
    })
    .then((data) => {
      // The "data" object contains the list of available voices and the voice synthesis params
      console.log("Speech is ready, voices are available", data);
    })
    .catch((e) => {
      console.error("An error occured while initializing : ", e);
    });


    const speak2 = ({ text }) => {
    
      speech
        .speak({
          text: text,
          listeners: {
            onstart: () => {
              console.log("Speak started");
             
              // console.log('these are the voices' + text);
            },
            onend: () => {
              console.log("Speak ended");
            },
            // onresume: () => {
            //   console.log("Resume utterance");
            // },
            // onboundary: (event) => {
            //   console.log(
            //     event.name +
            //       " boundary reached after " +
            //       event.elapsedTime +
            //       " milliseconds."
            //   );
            // },
          },
        })
        .then(() => {
          console.log("Success !");
          console.log("End of speech");
         
        })
        .catch((e) => {
          console.error("An error occurred :", e);
        });
    };

  const {
    error,
    interimResult,
    isRecording,
    results,
    startSpeechToText,
    stopSpeechToText,
  } = useSpeechToText({
    continuous: true,
    useLegacyResults: false,
  });

  useEffect(() => {
    // alert("transcript: " + transcript);
    // speak2({ text: "hello sekhar how are you" });
  }, [transcript]);

  console.log(results);

  const methoddd = () => {
    SpeechRecognition.stopListening();
    SpeechRecognition.startListening();
  }

  if (error)
    return (
      <p>
        Web Speech API is not available in this browser {error.toString()} 🤷‍
      </p>
    );

  return (
    <div>
      <button onClick={() => speak2({text: "hell sekhar"})}>speck it </button>
      <h1>Recording: {isRecording.toString()}</h1>
      <button onClick={isRecording ? stopSpeechToText : startSpeechToText}>
        {isRecording ? "Stop Recording" : "Start Recording"}
      </button>

      <ul>
        {results.map((result,key) => (
          <li key={result.timestamp}>{ key === results.length - 1 ? `${result.transcript}`: ""}</li>
        ))}
       
      </ul>
    </div>
  );
}
